import { createContext, useContext } from "react";

import type {
  RadioAlign,
  RadioIndicatorPosition,
  RadioLayout,
} from "./Radio.types";

export const RadioGroupContext = createContext<{
  layout: RadioLayout;
  indicatorPosition: RadioIndicatorPosition;
  align: RadioAlign;
  invalid: boolean;
}>({
  layout: "default",
  indicatorPosition: "start",
  align: "start",
  invalid: false,
});

export function useRadioGroupContext() {
  return useContext(RadioGroupContext);
}
